// QA fixture markers leaked into the menu API by environment seeding scripts
// (for example `CODEX-QA-P3-ENV-STAFF-MATRIX`). They must never reach the UI.
const QA_FIXTURE_MODULE_TITLE = /^codex-qa-[a-z0-9]+-env/i;
const QA_FIXTURE_MODULE_ROUTE = "codex-qa-";

export const isQaFixtureModule = (module) => {
  if (!module || typeof module !== "object") return false;

  const title = typeof module.title === "string" ? module.title.trim() : "";
  const route = typeof module.route === "string" ? module.route.trim().toLowerCase() : "";

  return QA_FIXTURE_MODULE_TITLE.test(title) || route.startsWith(QA_FIXTURE_MODULE_ROUTE);
};

export const visibleMenuModules = (modules) => (
  Array.isArray(modules) ? modules.filter((module) => module && !isQaFixtureModule(module)) : []
);

const explicitlyDenied = (value) => value === false || value === 0 || value === "0";

export const hasValidAuthSession = (auth) => Boolean(
  auth
    && auth.isLoggedIn === true
    && typeof auth.token === "string"
    && auth.token.trim()
    && auth.user
    && typeof auth.user === "object"
    && !Array.isArray(auth.user),
);

export const websocketUrlForToken = (configuredUrl, token) => {
  if (typeof configuredUrl !== "string" || !configuredUrl.trim() || !token) return null;

  try {
    const url = new URL(configuredUrl);
    if (url.protocol !== "ws:" && url.protocol !== "wss:") return null;
    url.searchParams.set("token", token);
    return url.toString();
  } catch (_error) {
    return null;
  }
};

export const isResolvedModuleVisible = (module, featureAccess) => {
  if (!module || isQaFixtureModule(module) || explicitlyDenied(module.is_access) || explicitlyDenied(module.access)) return false;

  const featureName = module.feature_name || module.featureName;
  if (!featureName) return true;

  const enabledFeatures = featureAccess && featureAccess.feature_access_data;
  return Array.isArray(enabledFeatures) && enabledFeatures.includes(featureName);
};
